export default "__VITE_ASSET__Cg$VzQsT__"